import { Grid, Typography } from "@mui/material";
import * as MUIICon from "@mui/icons-material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { sprintf } from "sprintf-js";
import { baseURL } from "../../api";
import { serverAddress } from "../../config";
import { Global_Data } from "../../globalData/GlobalData";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

function VARNUMBER({ data, varValue, format, dataTableValue, value, id }) {
  const { token, textValue, setTextValue, mainFormData, modalActionTypeAndID } = Global_Data();

  const [varNumberData, setVarNumberData] = useState();
  const [finalData, setFinalData] = useState();
  const { loading, trackRequest } = usePendingRequests();

  let varNumberValueData = (mainFormData?.form?.sFormAction == "VIEW" && varNumberData?.[data?.component?.sName]) ? varNumberData?.[data?.component?.sName] : (value ? value : data?.data?.sAction == 'CASCADE' ? textValue?.[data?.component?.sName] : varValue?.[data?.component?.sName]);
  const styleFormatData = format?.data?.records?.find(
    item =>
      item?.sFieldName == data?.component?.sName &&
      item?.sFieldValue == varNumberValueData
  );
  const Icons = MUIICon[styleFormatData?.sStatusIcon];

  let isPositive = true;
  const varNumberValueDataFormatted = varNumberValueData?.toString().includes(",") ? varNumberValueData?.replaceAll(",", "") : varNumberValueData;
  const dataTableValueFormatted = dataTableValue?.toString().includes(",") ? dataTableValue?.replaceAll(",", "") : dataTableValue;

  if (varNumberValueDataFormatted || dataTableValueFormatted) {
    isPositive = Number(varNumberValueDataFormatted || dataTableValueFormatted) >= 0;
  }

  const formatedData = varNumberValueDataFormatted
    ? sprintf(
      isPositive ? data.component.sPositiveFormat : data.component.sNegativeFormat,
      (varNumberValueDataFormatted || dataTableValueFormatted)
    )
    : "";

  function addThousandSeparatorToNumber(numberString) {
    const formattedNumber = parseFloat(numberString).toFixed(2);
    const [integerPart, decimalPart] = formattedNumber.split(".");
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (data?.component?.iDecimalPlaces == 0) {
      return `${formattedIntegerPart}`;
    }
    if (data.component.iDecimalPlaces == 1) {
      return parseFloat(`${formattedIntegerPart}.${decimalPart}`).toFixed(1);
    }
    if (data.component.iDecimalPlaces == 2) {
      return `${formattedIntegerPart}.${decimalPart}`;
    }
  }

  function formatAllNumbersInString(input) {
    return input.replace(/-?\d+(\.\d+)?/g, match => addThousandSeparatorToNumber(match));
  }

  const prefix = String(data?.component?.sPrefix ?? "").trim();
  const suffix = String(data?.component?.sSuffix ?? "").trim();
  const displayData = finalData || formatedData;
  const hasDisplayData = Boolean(displayData) && !displayData.includes(undefined);
  const formattedDisplayData = hasDisplayData
    ? formatAllNumbersInString(displayData)
    : "0.00";

  let sxProps = isPositive
    ? data?.component?.sPositiveProps
    : data?.component?.sNegativeProps || {};
  const justification = String(data?.component?.sJustify ?? "").trim().toLowerCase();
  const configuredTypographySx = sxProps?.sx;
  const typographySx = [
    ...(Array.isArray(configuredTypographySx)
      ? configuredTypographySx
      : configuredTypographySx
        ? [configuredTypographySx]
        : []),
    {
      textAlign: justification || undefined,
      width: "100%"
    }
  ];
  const configuredGridSx = data?.grid_props?.sx;
  const gridSx = [
    ...(Array.isArray(configuredGridSx)
      ? configuredGridSx
      : configuredGridSx
        ? [configuredGridSx]
        : []),
    justification ? { width: "100%" } : {}
  ];

  function replaceUriParams(data, uri) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        if (value !== "" && value !== undefined && value !== null) {
          const regex = new RegExp(`{${key}}`, "g");
          uri = uri.replace(regex, value);
        }
      }
    }
    return uri;
  }

  function validateAndGetParams(uri) {
    const url = new URL(uri);
    const params = {};
    url.searchParams.forEach((value, key) => {
        params[key] = value;
    });
    for (const [key, value] of Object.entries(params)) {
        if (!value) {
            console.log(`The parameter "${key}" is missing or empty.`);
            return false;
        }
    }
    return true;
  }

  async function fetchData() {
    const processedURL = replaceUriParams(textValue, data.data.sDataSource);
    const isAccountToPresent = processedURL.match(/[?&]accountto=([^&]*)/);
    const isValid = !isAccountToPresent || (isAccountToPresent[1] !== '');
    if (!processedURL.includes('{') && !processedURL.includes('[') && processedURL && isValid && validateAndGetParams(`${baseURL}${processedURL}`)) {
      trackRequest(() =>
        axios.get(`${baseURL}${replaceUriParams(textValue, data.data.sDataSource)}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      )
        .then(result => {
          if (result?.data?.data?.records[0][data.data.sValueField] !== ""){
            setTextValue((pre) => ({ ...pre, [data.component.sName]: result?.data?.data?.records[0][data.data.sValueField] + "" }))
            setVarNumberData((prev) => ({...prev, [data.component.sName]: result?.data?.data?.records[0][data.data.sValueField] + ""}))
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    }
  }

  useEffect(() => {
    if(varNumberData){
      let varNumberValueData = (varNumberData?.[data?.component?.sName]) ? varNumberData?.[data?.component?.sName] : (value ? value : data?.data?.sAction == 'CASCADE' ? textValue?.[data?.component?.sName] : varValue?.[data?.component?.sName]);
      let isPositive = true;
      const varNumberValueDataFormatted = varNumberValueData?.toString().includes(",") ? varNumberValueData?.replaceAll(",", "") : varNumberValueData;
      const dataTableValueFormatted = dataTableValue?.toString().includes(",") ? dataTableValue?.replaceAll(",", "") : dataTableValue;

      if (varNumberValueDataFormatted || dataTableValueFormatted) {
        isPositive = Number(varNumberValueDataFormatted || dataTableValueFormatted) >= 0;
      }

      const formatedData = varNumberValueDataFormatted
        ? sprintf(
          isPositive ? data.component.sPositiveFormat : data.component.sNegativeFormat,
          (varNumberValueDataFormatted || dataTableValueFormatted)
        )
        : "";
      setFinalData(formatedData);
    }
  }, [varNumberData])

  useEffect(() => {
    fetchData()
  }, [textValue[data.data.sDataAware.replace('{', '').replace('}', '')]]);

  return (
    <Grid item {...data?.grid_props} sx={gridSx}>
      <ComponentLoadingBoundary
        loading={loading}
        label={`Loading ${data?.component?.sName}`}
        minHeight={28}
        size={20}
      >
        <Typography
          {...sxProps}
          sx={typographySx}
          id={id ? id : data?.component?.sName}
        >
          {styleFormatData?.sStatusIcon && <Icons />}
          {prefix && <>{prefix}{" "}</>}
          {hasDisplayData
            ? <span dangerouslySetInnerHTML={{ __html: formattedDisplayData }} />
            : formattedDisplayData}
          {suffix && <>{" "}{suffix}</>}
        </Typography>
      </ComponentLoadingBoundary>
    </Grid>
  );
}

export default VARNUMBER;
